import { Container, Stack } from "@mui/material";
import { ArenaRedirect } from "@ssf/play-components";

import { Menu } from "./index.js";

const PLAY_WEB_URL = process.env.PLAY_WEB_URL;
if (!PLAY_WEB_URL) {
  throw new Error("env `PLAY_WEB_URL` is not set");
}

export const Header = () => {
  return (
    <>
      <Container sx={{ "&&": { maxWidth: "100%" } }}>
        <Stack
          spacing={1}
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: { xs: "flex-end", md: "center" },
            minHeight: 48,
          }}
        >
          <Menu />
        </Stack>
      </Container>

      <ArenaRedirect
        actionProps={(groupId) => ({
          component: "a",
          href: `${PLAY_WEB_URL}/memdb?groupId=${groupId}`,
        })}
      />
    </>
  );
};
